import Swiper from 'swiper'
import {A11y, Autoplay, Navigation} from 'swiper/modules'

const body = document.querySelector('body');
const home = body.classList.contains('home');

if (home) {

        // Slider Reviews
    const reviewsSlideshow = document.querySelector('.reviews__container .swiper-container') !== null;

    if (reviewsSlideshow) {
        let nbSlides = document.querySelectorAll('.reviews__container .swiper-container .swiper-slide').length;
        // let reviewsNav = document.getElementById('js-reviewsNav');
        
        let config = {
            modules: [A11y, Navigation],
            effect: 'slide',
            grabCursor: 'true',
            speed: 700,
            loop: false,

            navigation: {
                nextEl: `.reviews__navigation .swiper-button-next`,
                prevEl: `.reviews__navigation .swiper-button-prev`,
            },

            breakpoints: {
                1201: {
                    slidesPerView : 3,
                    spaceBetween: 30,
                },
                961: {
                    slidesPerView : 3,
                    spaceBetween: 20,
                },
                641: {
                    slidesPerView : 2,
                    spaceBetween: 20,
                },
                0: {
                    slidesPerView : 1,
                    spaceBetween: 20
                }
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
            
            // on: {
            //     breakpoint: function () {
            //         if(window.innerWidth > 960 && nbSlides <= 3) {
            //             console.log(reviewsNav)
            //             reviewsNav.classList.add('js-reviewsNav--no-slider');
            //         }
                    
            //         if(960 >= window.innerWidth > 640 && nbSlides <= 2){
            //             reviewsNav.classList.add('js-reviewsNav--no-slider');
            //         }
            //         else if(960 >= window.innerWidth > 640 && nbSlides > 2){
            //             reviewsNav.classList.remove('js-reviewsNav--no-slider');
            //         }
                    
            //         if(window.innerWidth <= 640 && nbSlides <= 1) {
            //             reviewsNav.classList.add('js-reviewsNav--no-slider');
            //         }
            //     }
            // }
        }

        if(nbSlides > 1) {
            let swiperReviews = new Swiper('.reviews__container .swiper-container', config);
        }
        
    }
}